export const LOAD_ALL_ABSTRACT_DATA_SUCCESS = "LOAD_ALL_ABSTRACT_DATA_SUCCESS";
export const LOAD_ALL_ABSTRACT_DATA_ERROR = "LOAD_ALL_ABSTRACT_DATA_ERROR";
export const LOAD_USER_DATA_SUCCESS = "LOAD_ABSTRACT_DATA_SUCCESS";
export const LOAD_ALL_PRODUCT_SUCCESS = "LOAD_ALL_PRODUCT_SUCCESS";
export const LOAD_ALL_COUNTRY_SUCCESS = "LOAD_ALL_COUNTRY_SUCCESS";
export const LOAD_ALL_EXPLANATION_SUCCESS = "LOAD_ALL_EXPLANATION_SUCCESS";
export const LOAD_ALL_STATUS_SUCCESS = "LOAD_ALL_STATUS_SUCCESS";
export const LOAD_ALL_ALERTS_SUCCESS = "LOAD_ALL_ALERTS_SUCCESS";
export const ADD_ABSTRACT_SUCCESS = "ADD_ABSTRACT_SUCCESS";
export const UPDATE_ABSTRACT_SUCCESS = "UPDATE_ABSTRACT_SUCCESS";
export const LOAD_ABSTRACT_DETAIL_SUCCESS = "LOAD_ABSTRACT_DETAIL_SUCCESS";

export const OPEN_WARNING_MODAL = "OPEN_WARNING_MODAL";
export const CLOSE_WARNING_MODAL = "CLOSE_WARNING_MODAL";
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const LOAD_USERS_DATA_SUCCESS = "LOAD_USERS_DATA_SUCCESS";
export const LOAD_ACTIVE_INACTIVE_USERS_DATA_SUCCESS = "LOAD_ACTIVE_INACTIVE_USERS_DATA_SUCCESS";
export const LOAD_ABSTRACTS_PG_DATA_SUCCESS = "LOAD_ABSTRACTS_PG_DATA_SUCCESS";
export const LOAD_ABSTRACTS_DATA_SUCCESS = "LOAD_ABSTRACTS_DATA_SUCCESS";
export const ADD_ABSTRACT_BULK_SUCCESS = "ADD_ABSTRACT_BULK_SUCCESS";
export const LOAD_ALL_ABSTRACT_DATA_PAGINATION_SUCCESS = "LOAD_ALL_ABSTRACT_DATA_PAGINATION_SUCCESS"


export const LOAD_LOGGED_USER_SUCCESS = "LOAD_LOGGED_USER_SUCCESS";
export const LOAD_AUTH_PROVIDER_SUCCESS = "LOAD_AUTH_PROVIDER_SUCCESS";




